// routes/UserRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Users from '../components/Users/Users';
import UserDashboard from '../components/Users/UserDashboard';
import AddUser from '../components/Users/AddUser';
import ChangePassword from '../components/Users/ChangePassword';
import ViewProfile from '../components/Users/ViewProfile';
import UploadDocuments from '../components/Users/UploadDocuments';
import Personalisation from '../components/Users/Personalisation';
import { AccountListProvider } from '../context/AccountListContext';

export const userRoutes = (
  <Route path="/users" element={<MainLayout />}>
    <Route path="user_dashboard" element={<UserDashboard />} />
    <Route index element={<Users />} />
    <Route path="add_user" element={<AddUser />} />
    <Route path="change_password" element={<ChangePassword />} />
    <Route path="edit_user/:userId" element={<AddUser />} />
    <Route path="view_profile" element={<ViewProfile />} />
    {/* <Route path="personalisation" element={<Personalisation />} /> */}

    <Route path="personalisation">
      <Route index element={
        <AccountListProvider>
          <Personalisation />
        </AccountListProvider>
      } />
    </Route>

    <Route path="upload_documents" element={<UploadDocuments />} />
  </Route>
);
